/**
 * Created by liux on 17/7/7.
 * @param get key ,set name value opt
 * @return value or undefined
 */
export default {
  get (sKey) {
    return decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null;
  },
  set (name, val, obj) {
    if (!name || typeof name != 'string' ||
      !val || typeof val != 'string') {
      return false;
    }
    var str = name + '=' + val + ';';
    if (obj && obj.expires) {
      var d = new Date();
      d.setTime(d.getTime() + (obj.expires * 24 * 60 * 60 * 1000));
      var expires = 'expires=' + d.toUTCString();
      str += expires + ';';
    }

    if (obj && obj.path) {
      str += 'path=' + obj.path + ';';
    }
    document.cookie = str;
  },
  clear(name) {
    this.set(name, '', {'expires': -1});
  },

};
